import { render, staticRenderFns } from "./CedantReinsurerMenu.vue?vue&type=template&id=ac24e044&"
import script from "./CedantReinsurerMenu.vue?vue&type=script&lang=js&"
export * from "./CedantReinsurerMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports